<p-button [label]="playerName" (onClick)="onToggle($event)" styleClass="p-button-link p-0"></p-button>

<p-dialog 
    [(visible)]="dialogVisible" 
    [modal]="true" 
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    styleClass="surface-card shadow-2"
    [style]="{width: '800px', maxHeight: '85vh'}"
    (onHide)="onDialogHide()">
    
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2 p-3">            
            <i class="pi pi-user text-primary text-xl mr-2"></i>
            <span class="text-900 font-medium text-xl">Player: {{playerName}}</span>
        </div>
    </ng-template>
    
    <div class="p-3">
        <!-- Watchlist and Position Selection -->
        <div class="grid mb-4">
            <div class="col-12 md:col-6">
                <label class="block text-500 font-medium mb-2">Select Watchlist</label>
                <p-multiSelect 
                    [options]="watchlists" 
                    [(ngModel)]="selectedWatchlists"
                    optionLabel="description" 
                    optionValue="id"
                    placeholder="Select Watchlists"
                    display="chip"
                    (onFocus)="onMultiSelectFocus()"
                    styleClass="w-full"
                    panelStyleClass="w-full">
                    <ng-template let-watchlist pTemplate="item">
                        <div class="flex align-items-center justify-content-between w-full p-2" style="padding-left: 1rem;">
                            <div class="flex align-items-center" (click)="onItemClick(watchlist, $event)">
                                <span>{{ watchlist.description }}</span>
                            </div>
                            <div class="delete-button-container"
                                 *ngIf="canDeleteWatchlist(watchlist)"
                                 (click)="onDeleteWatchlistClick(watchlist, $event)"
                                 (mousedown)="$event.stopPropagation()"
                                 (mouseup)="$event.stopPropagation()">
                                <i class="pi pi-trash text-pink-500 ml-2 cursor-pointer" pTooltip="Delete Watchlist" tooltipPosition="left"></i>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <div class="p-3">
                            <ng-container *ngIf="!showAddWatchlistInput">
                                <p-button 
                                    label="Add New" 
                                    icon="pi pi-plus"
                                    styleClass="w-full"
                                    (onClick)="onFooterClick($event, true)"
                                    severity="secondary"
                                    styleClass="p-button-text">
                                </p-button>
                            </ng-container>
                            <ng-container *ngIf="showAddWatchlistInput">
                                <input 
                                    type="text" 
                                    pInputText 
                                    [(ngModel)]="newWatchlistDescription" 
                                    placeholder="Enter watchlist name..."
                                    class="w-full mb-2"
                                    (keyup.enter)="createWatchlistInline()"
                                    (mousedown)="$event.stopPropagation()"
                                    #watchlistInput>
                                <div class="flex gap-2">
                                    <p-button 
                                        label="Cancel" 
                                        styleClass="p-button-text p-button-danger flex-1"
                                        (onClick)="onFooterClick($event, false)"
                                        [disabled]="loading">
                                    </p-button>
                                    <p-button 
                                        label="Create" 
                                        icon="pi pi-plus"
                                        styleClass="p-button-text flex-1"
                                        (onClick)="onAddWatchlist()"
                                        [disabled]="!newWatchlistDescription.trim() || loading"
                                        severity="secondary">
                                    </p-button>
                                </div>
                            </ng-container>
                        </div>
                    </ng-template>
                </p-multiSelect>
            </div>
            <div class="col-12 md:col-6">
                <label class="block text-500 font-medium mb-2">Select Position</label>
                <p-dropdown 
                    [options]="customPositions" 
                    [(ngModel)]="position" 
                    optionLabel="name" 
                    optionValue="key"
                    placeholder="Select Position"
                    [showClear]="true"
                    (onClear)="onClearPosition()"
                    styleClass="w-full">
                </p-dropdown>
            </div>
        </div>

        <!-- Player Section -->
        <div class="mb-4">
            <div class="flex align-items-center gap-2 mb-3">
                <i class="pi pi-user text-primary text-lg mr-2"></i>
                <h3 class="text-900 font-medium m-0 text-lg">Player</h3>
            </div>

            <div class="grid">
                <div class="col-2">
                    <label class="block text-500 font-medium mb-2">Source</label>
                </div>
                <div class="col-10">
                    <label class="block text-500 font-medium mb-2">Player Name</label>
                </div>
            </div>

            <div class="grid mb-3" *ngFor="let sourceKey of getPlayerSources()">
                <div class="col-2">
                    <span class="text-900 font-medium">{{getSourceLabel(sourceKey)}}</span>
                </div>
                <div class="col-10">
                    <p-dropdown 
                        [options]="sources[sourceKey].filteredOptions" 
                        [(ngModel)]="sources[sourceKey].selectedOption"
                        optionLabel="name" 
                        optionValue="name"
                        placeholder="Player Name"
                        [showClear]="true"
                        [filter]="true"
                        (onFilter)="onPlayerFilter($event, sourceKey)"
                        (onFocus)="onFocus(sourceKey)"
                        styleClass="w-full">
                    </p-dropdown>
                </div>
            </div>
        </div>

        <!-- Team Section -->
        <div class="mb-4">
            <div class="flex align-items-center gap-2 mb-3">
                <i class="pi pi-users text-primary text-lg mr-2"></i>
                <h3 class="text-900 font-medium m-0 text-lg">Team: {{team}}</h3>
            </div>

            <div class="grid">
                <div class="col-2">
                    <label class="block text-500 font-medium mb-2">Source</label>
                </div>
                <div class="col-10">
                    <label class="block text-500 font-medium mb-2">Team Name</label>
                </div>
            </div>

            <div class="grid mb-3" *ngFor="let sourceKey of getTeamSources()">
                <div class="col-2">
                    <span class="text-900 font-medium">{{getSourceLabel(sourceKey)}}</span>
                </div>
                <div class="col-10">
                    <p-dropdown 
                        [options]="sources[sourceKey].filteredOptions" 
                        [(ngModel)]="sources[sourceKey].selectedOption"
                        optionLabel="name" 
                        optionValue="name"
                        placeholder="Team Name"
                        [showClear]="true"
                        [filter]="true"
                        (onFilter)="onTeamFilter($event, sourceKey)"
                        (onFocus)="onFocus(sourceKey)"
                        styleClass="w-full">
                    </p-dropdown>
                </div>
            </div>
        </div>

        <!-- Notes Section -->
        <div class="border-top-1 surface-border pt-4">
            <div class="flex align-items-center gap-2 mb-3">
                <i class="pi pi-file-edit text-primary text-lg mr-2"></i>
                <h3 class="text-900 font-medium m-0 text-lg">Notes</h3>
            </div>

            <!-- Tabs (pill style) -->
            <div class="flex bg-blue-50 border-round mb-3 p-1 w-fit">
                <p-button
                  [label]="'My Notes (' + displayedNotes.length + ')'"
                  [styleClass]="activeNotesTab === 'my' ? 'p-button-sm bg-primary text-white border-round-left' : 'p-button-sm p-button-text text-primary border-round-left'"
                  (onClick)="setActiveNotesTab('my')"
                ></p-button>
                <p-button
                  [label]="'All Notes'"
                  [styleClass]="activeNotesTab === 'all' ? 'p-button-sm bg-primary text-white border-round-right' : 'p-button-sm p-button-text text-primary border-round-right'"
                  (onClick)="setActiveNotesTab('all')"
                ></p-button>
            </div>

            <!-- Add Note Textarea -->
            <div class="surface-100 border-1 border-round p-3 mb-3">
                <textarea
                    pInputTextarea
                    [(ngModel)]="newNoteText"
                    placeholder="Add a new note..."
                    rows="4"
                    style="width: 100%; min-width: 0; resize: vertical; box-sizing: border-box;"
                    class="block"
                ></textarea>
                <div class="flex gap-3 mt-3 justify-content-end">
                    <p-button 
                        label="Add Note" 
                        styleClass="p-button-primary"
                        (onClick)="addNote()"
                        [disabled]="!newNoteText.trim() || loading"
                    ></p-button>
                </div>
            </div>

            <!-- Notes List -->
            <div *ngIf="displayedNotes.length === 0">
                <div class="surface-100 p-3 border-round mb-3">
                    <div class="text-sm text-500">No notes added yet.</div>
                </div>
            </div>
            <div *ngIf="displayedNotes.length > 0">
                <div class="surface-100 p-3 border-round mb-3" *ngFor="let note of displayedNotes">
                    <div class="flex justify-content-between align-items-start mb-2">
                        <div class="text-sm font-medium">Note</div>
                        <div class="text-xs text-500">{{note.date | date:'MM/dd/yyyy'}}</div>
                    </div>
                    <div class="text-sm text-500 leading-relaxed mb-2">{{note.content}}</div>
                    <div class="flex justify-content-end">
                        <p-button
                            *ngIf="canDeleteNote(note)"
                            icon="pi pi-trash"
                            styleClass="p-button-text p-button-sm p-button-danger"
                            (onClick)="confirmDeleteNote(note)"
                            pTooltip="Delete Note">
                        </p-button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-between w-full">
            <p-button 
                label="Cancel" 
                styleClass="p-button-outlined"
                (onClick)="onCancel()"
                [disabled]="loading">
            </p-button>
            <p-button 
                label="Save" 
                icon="pi pi-save"
                (onClick)="onSave()"
                [loading]="loading">
            </p-button>
        </div>
    </ng-template>
</p-dialog>
 